<template>
  <v-row class="center-vertically">
    <v-col cols="4">
      <h4 class="text-h4 center-vertically">
        <slot name="icon">
          <v-icon
            v-if="icon"
            class="title-icon mr-4"
          >
            {{ icon }}
          </v-icon>
        </slot>
        {{ title }}
      </h4>
    </v-col>
    <v-col
      v-if="$slots.actions"
      class="text-right"
    >
      <slot name="actions" />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    title: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.title-icon {
  color: gray;
}
.center-vertically {
  align-items: center;
  display: flex;
}
</style>
